module.exports = __webpack_public_path__ + "img/bisect.0334fee7.svg";